import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";

import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { useHistory } from "react-router-dom";



import {  useDispatch } from "react-redux";

import { useConfirm } from "material-ui-confirm";
import {
  
  showErrorSnackbar,
} from "store/actions/snackbarMessage";


import { NavLink } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { StoreContext } from "../../context/store";

const useStyles = makeStyles((theme) => ({
  root: {},
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  exportButton: {
    marginRight: theme.spacing(1),
  },
  searchInput: {
    marginRight: theme.spacing(1),
  },
}));

const PromotionsToolbar = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  
  const confirm = useConfirm();
  const dispatch = useDispatch();

  const [buttonLoading, setButtonLoading] = useState(false);


  const { selectIds } = useContext(
    StoreContext
  );

  


  const showErrorMessage = (msg) => dispatch(showErrorSnackbar(msg));



  const deletePromotion = () => {
    //console.log("selectedTransactionIds", selectedTransactionIds);
    if (selectIds && selectIds[0] && selectIds[0].length !== 1) {
      showErrorMessage("Please select a prmotion.");
      return;
    }

    

    confirm({ description: "You are about to delete promotions!" })
      .then(() => {
        setButtonLoading(true);
        props.deleteProxy(selectIds[0], () => {
          setButtonLoading(false);
        })
      })
      .catch(() => {});
  };





  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />


        <NavLink to="/promotionTypes" className={classes.textLink}>
          <Tooltip title="new promotion">
            <IconButton aria-label="new promotion">
              <AddCircleOutlineIcon />
            </IconButton>
          </Tooltip>
        </NavLink>

        <IconButton
          aria-label="delete"
          onClick={deletePromotion}
          disabled={buttonLoading}
        >
          <DeleteIcon />
        </IconButton>

  
      

  
      </div>

    </div>
  );
};

PromotionsToolbar.propTypes = {
  className: PropTypes.string,
};

export default PromotionsToolbar;
